import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DashboardStyles } from '../../../styles/dashboard';

const useStyles = makeStyles(DashboardStyles);

const VehicleWarningModal = (props) => {
	const classes = useStyles();
	return (
		<Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title" PaperProps={{classes: {root: classes.dialogPaper}}}>
			<DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>Warning</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				{props.message}
			</DialogContent>
			<DialogActions className={classes.DialogActions}>
				<Button color="primary" variant="contained" size="small" onClick={() => props.handleClose()}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleWarningModal);